import { CssBaseline, StyledEngineProvider, ThemeProvider } from '@mui/material';
import * as React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { NavigationScroll } from './components/Layout';
import { RoutesComponent } from './routes';
import themes from './themes';

import { Loading } from '@/components/Elements';
import { ReduxProvider } from '@/state';

function App() {
    return (
        <React.Suspense fallback={<Loading />}>
            <ReduxProvider>
                <Router>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={themes()}>
                            <CssBaseline />
                            <NavigationScroll>
                                <RoutesComponent />
                            </NavigationScroll>
                        </ThemeProvider>
                    </StyledEngineProvider>
                </Router>
            </ReduxProvider>
        </React.Suspense>
    );
}

export default App;
